import HoldingPage from "./HoldingPage";

export default HoldingPage;
